import React from 'react';
import {Referral} from "../domains";
import {SiblingReferralOfferDetailLink} from './SiblingReferralOfferDetailLink';

type Props = {
    referral: Referral | null;
}

export function SiblingDetailsAllProvider({referral}: Props) {
    if (referral === null) {
        return <div/>;
    }

    let siblings = referral.clientSiblingReferralsAllProvider || [];
    siblings = siblings.filter((sibling) => sibling.siblingReferralGuid !== null);

    if (siblings.length === 0) {
        return <div/>;
    }

    return (
        <div className="flex pb-2">
            <div className="w-1/2">
                Sibling
            </div>
            <div className="w-1/2 flex flex-wrap">
                {
                    siblings.map((s) => (
                        <SiblingReferralOfferDetailLink referral={referral} size={400} className="mr-2 pb-2"
                                                        key={s.guid}
                                                        siblingReferral={s}/>
                    ))
                }
            </div>
        </div>
    );
}